'use client';

import flush from 'just-flush';
import { defaultLanguage } from '@stereoagency/constants';
import { ResearchPlatformHero as UIResearchPlatformHero } from '@stereoagency/ui';
import { researchPlatformPageQuery } from './researchPlatformPageQuery';
import {
  findInKeyArray,
  formatPhoneNumberLink,
  formatProfileName,
  platformFromURL,
  sanityImageAsProps
} from '@/utils';
import { SingleProfile } from '../GroupOrPlatformDepartmentsSection.client';

type Props = {
  lang: string;
  researchPlatform: (typeof researchPlatformPageQuery)[1];
  researchPlatformLeaderProfile?: SingleProfile;
};

export default function ResearchPlatformHero({
  lang,
  researchPlatform,
  researchPlatformLeaderProfile
}: Props) {
  const groupTitle = researchPlatform.title
    ? findInKeyArray(researchPlatform.title, [lang, defaultLanguage.id])
    : null;

  const links = flush([
    researchPlatformLeaderProfile?.email
      ? [
          `mailto:${researchPlatformLeaderProfile.email}`,
          researchPlatformLeaderProfile.email
        ]
      : null,
    researchPlatformLeaderProfile?.phone
      ? [
          formatPhoneNumberLink(researchPlatformLeaderProfile.phone),
          researchPlatformLeaderProfile.phone
        ]
      : null,
    researchPlatformLeaderProfile?.website
      ? [
          researchPlatformLeaderProfile.website,
          researchPlatformLeaderProfile.website.replace(/^[a-z]:\/\//, '')
        ]
      : null
  ]);

  if (
    !researchPlatformLeaderProfile?.image?.asset._ref ||
    !researchPlatformLeaderProfile.name
  ) {
    return null;
  }

  return (
    <UIResearchPlatformHero
      image={sanityImageAsProps(researchPlatformLeaderProfile.image)}
      name={formatProfileName(researchPlatformLeaderProfile)}
      title={groupTitle?.value}
      description={researchPlatformLeaderProfile?.address}
      actions={links.map(([link, label]) => ({
        target: '_blank',
        href: link,
        label
      }))}
      socialActions={researchPlatformLeaderProfile.socials?.map((social) => ({
        href: social,
        platform: platformFromURL(social),
        target: '_blank'
      }))}
      accentColor="--colors-blue-700"
    />
  );
}
